import {
	Component,
	ChangeDetectionStrategy,
	Input,
	Output,
	EventEmitter,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { CmmsScheduleMonthChoices } from '@app/pages/cmms/interfaces/scheduled-value.interface';

import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'months-period-content',
	templateUrl: './months-period-content.component.html',
	styleUrls: ['./months-period-content.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatFormFieldModule, MatSelectModule, NgxTolgeeModule],
})
export class MonthsPeriodContentComponent {
	@Input() selectedChoice: CmmsScheduleMonthChoices = 'FIRST_DAY';

	@Output() valueChanged = new EventEmitter<CmmsScheduleMonthChoices>();

	choices = [
		{
			value: 'FIRST_DAY',
			label: 'periods_common_first_day_of_month',
		},
		{
			value: 'LAST_DAY',
			label: 'periods_common_last_day_of_month',
		},
	];

	selectedChoiceChange($event: MatSelectChange) {
		this.valueChanged.emit($event.value);
	}
}
